import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

export const ContactForm = () => {
    const formInitialDetails = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''
    }
    const [formDetails, setFormDetails] = useState(formInitialDetails);
    const [buttonText, setButtonText] = useState('Send');
    const [status, setStatus] = useState({});

    const onFormUpdate = (category, value) => {
      setFormDetails({
        ...formDetails,
        [category]: value
      })
    }

    // Email validation helper function
    const validateEmail = (email) => {
        return String(email)
          .toLowerCase()
          .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    };

    const handleSubmit = async (e) => {
      e.preventDefault();

      if (!formDetails.firstName || !formDetails.lastName || !formDetails.email || !formDetails.message) {
        setStatus({ success: false, message: 'Please fill in all required fields.' });
        return; // Stop the function here
      }
      
      if (!validateEmail(formDetails.email)) {
        setStatus({ success: false, message: 'Please enter a valid email address.' });
        return; 
      }

      setButtonText("Sending...");
      setStatus({});
      
      try {
          let response = await fetch("https://server-yfz3.onrender.com/contact", {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify(formDetails),
          });
          
          setButtonText("Send");
          let result = await response.json();
          
          if (result.code === 200) {
            setFormDetails(formInitialDetails);
            setStatus({ success: true, message: 'Message sent successfully'});
          } else {
            setStatus({ success: false, message: 'Something went wrong, please try again later.'});
          }
      } catch (error) {
          setButtonText("Send");
          setStatus({ success: false, message: 'Network error, please try again later.'});
      }
    };

    return (
        <section className="contact" id="contact">
            <Container>
                <Row className="align-items-center">
                    <Col md={6}>
                        <object 
                            data="/Peacock_Sam_Resume.pdf" 
                            type="application/pdf" 
                            width="100%" 
                            height="900px" 
                            style={{ borderRadius: '15px', backgroundColor: '#ffffff', overflow: 'hidden' }}
                        >
                            <p className="text-center mt-3">
                                Unable to display PDF. <br/>
                                <a href="/Peacock_Sam_Resume.pdf" download="Sam_Peacock_Resume.pdf" style={{ color: 'white', textDecoration: 'underline' }}>
                                    Download my resume instead!
                                </a>
                            </p>
                        </object>
                    </Col>
                    <Col md={6}>
                        <h2>Get In Touch</h2>
                        <form onSubmit={handleSubmit}>
                            <Row>
                                <Col size={12} sm={6} className="px-1">
                                    <input type="text" value={formDetails.firstName} placeholder="First Name" onChange={(e) => onFormUpdate('firstName', e.target.value)} />
                                </Col>
                                <Col size={12} sm={6} className="px-1">
                                    <input type="text" value={formDetails.lastName} placeholder="Last Name" onChange={(e) => onFormUpdate('lastName', e.target.value)}/>
                                </Col>
                                <Col size={12} sm={6} className="px-1">
                                    <input type="email" value={formDetails.email} placeholder="Email Address" onChange={(e) => onFormUpdate('email', e.target.value)} />
                                </Col>
                                <Col size={12} sm={6} className="px-1">
                                    <input type="tel" value={formDetails.phone} placeholder="Phone No. (Optional)" onChange={(e) => onFormUpdate('phone', e.target.value)}/>
                                </Col>
                                <Col size={12} className="px-1">
                                    <textarea rows="6" value={formDetails.message} placeholder="Message" onChange={(e) => onFormUpdate('message', e.target.value)}></textarea>
                                    <button type="submit"><span>{buttonText}</span></button>
                                </Col>
                                {
                                    status.message &&
                                    <Col>
                                        <p className={status.success === false ? "danger" : "success"}>{status.message}</p>
                                    </Col>
                                }
                            </Row>
                        </form>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}